import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ol", { class: "breadcrumb" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item active" }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-current": "location" }, "Creation hub")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "display-4" }, "Creation hub", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "col-lg-3 col-md-4 col-sm-6 mb-4" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["TitleTag"], { title: "Creation hub index" }),
    _createVNode($setup["CanonicalRouteTag"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      ($setup.hasFlag('can-create-creation'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "btn btn-success float-end",
            to: "/hub/upload"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Upload")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _hoisted_3,
      _hoisted_4,
      _createVNode($setup["Pagination"], {
        class: "row",
        "fetch-items": $setup.fetchItems,
        "use-route": "use-route",
        "emit-load": "emit-load",
        "max-count": 12
      }, {
        default: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["CreationListingItem"], { item: item }, null, 8, ["item"])
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}